module.exports = __webpack_public_path__ + "static/img/Poli-23000.90cf08f9.svg";